var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"overflow":"hidden"}},[_c('iframe',{staticClass:"iframe",attrs:{"src":`https://metabase-new.sharechat.com/public/dashboard/8e4c5b75-780b-401f-93ea-13adbb7ee29b?tsm_id=${_vm.retailerId}&date=${_vm.date}`,"title":"Aggregated Sales"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }